"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserListRowComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const notification_service_1 = require("./notification.service");
//VARIABLE MODELS
const user_1 = require("./user");
const permission_1 = require("./permission");
let UserListRowComponent = class UserListRowComponent {
    constructor(_talk) {
        this._talk = _talk;
        this.userPage = 1;
        this.passwordReset = { internal: true };
    }
    deleteUser() {
        return __awaiter(this, void 0, void 0, function* () {
            let confirm = yield this._talk.confirm(`Are you sure you want to delete ${this.user.email}?`);
            let result = yield confirm.result;
            this.user.deleted = true;
            this.user.convertRolesToIds();
            if (result) {
                this.user.loading = true;
                try {
                    yield this.user.update();
                    this._talk.broadcast('User Deleted Successfully');
                }
                catch (err) {
                    this._talk.broadcast(`Error deleting user: ${err}`);
                }
                this.user.loading = false;
            }
        });
    }
    restoreUser() {
        return __awaiter(this, void 0, void 0, function* () {
            let confirm = yield this._talk.confirm(`Are you sure you want to restore ${this.user.email}?`);
            let result = yield confirm.result;
            this.user.deleted = false;
            this.user.convertRolesToIds();
            if (result) {
                this.user.loading = true;
                try {
                    yield this.user.update();
                    this._talk.broadcast('User Restored Successfully');
                }
                catch (err) {
                    this._talk.broadcast(`Error restoring user: ${err}`);
                }
                this.user.loading = false;
            }
        });
    }
    showResetPassword() {
        this.passwordReset.show = true;
    }
};
exports.UserListRowComponent = UserListRowComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", user_1.User)
], UserListRowComponent.prototype, "user", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", permission_1.Permission)
], UserListRowComponent.prototype, "permission", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], UserListRowComponent.prototype, "roles", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], UserListRowComponent.prototype, "showOrgs", void 0);
exports.UserListRowComponent = UserListRowComponent = __decorate([
    (0, core_1.Component)({
        selector: 'user-list-row',
        templateUrl: 'app/user-list-row.component.html',
        styleUrls: ['styles/admin.component.css']
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService])
], UserListRowComponent);
//# sourceMappingURL=user-list-row.component.js.map